module.exports = __webpack_public_path__ + "media/backspace.8e7ed71f.mp3";